<template>
  <div>
    <el-dialog title="请假申请" :visible.sync="dialogVisible" width="50%" :before-close="cancel">
      <el-form ref="form" :model="form" class="mobile-ruleForm card-ruleForm" label-width="114px" label-position="left">
        <el-row>
          <div class="iscompanyQuit" v-if="form.staffId && form.beginTime">
            <img src="../../../assets/images/new/blueInfo.png" alt="" />当月累计已申请事假和年假共计{{ leaveObj.monthLeaveTotal }}天，本年度事假审批通过共{{ leaveObj.yearPersonalLeaveTotal }}天
          </div>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="staffName" label="请假店员" prop="staffName"
              v-if="userInfo.superManage">
              <el-select v-model="form.staffId" clearable placeholder="请选择" :disabled='isDisable'
                @change="onChangeStaff">
                <el-option v-for="item in allStaffList" :key="item.id" :label="item.staffName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="leaveCateId" label="请假类型" prop="leaveCateId">
              <el-select v-model="form.leaveCateId" clearable placeholder="请选择">
                <el-option v-for="item in optionName" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="beginTime" label="开始时间" prop="beginTime">
              <el-date-picker v-model="form.beginTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                @change="startTime" :clearable="false">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="endTime" label="结束时间" prop="endTime">
              <el-date-picker v-model="form.endTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                @change="endTime" :clearable="false">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item-update" ref="leaveDayNum" label="请假天数" prop="leaveDayNum">
              <el-input v-model="form.leaveDayNum" placeholder="请输入请假天数" maxlength="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="el-form-item-update" ref="leaveReason" label="备注" prop="leaveReason">
          <el-input type="textarea" maxlength="150" show-word-limit :rows="3" placeholder="请输入备注"
            v-model="form.leaveReason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提交申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
  mixins: [minxin],
  data () {
    return {
      dialogVisible: false,
      optionName: [], // 请假人
      allStaffList: [], // 请假类型
      form: {
        staffId: '',
        leaveCateId: '',
        beginTime: '',
        endTime: '',
        leaveDayNum: '',
        leaveReason: ''
      },
      userInfo: {},
      isDisable: false,
      leaveObj: {
        monthLeaveTotal: 0,
        yearPersonalLeaveTotal: 0
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$on('set', function (org) {
        Object.assign(this.$data, this.$options.data())
        this.userInfo = this.$store.getters.ShopInfo;
        this.dialogVisible = true;
        this.getAllStaff();
        if (sessionStorage.getItem('attendanceParmas')) {
          let obj = JSON.parse(sessionStorage.getItem("attendanceParmas"));
          this.form.staffId = obj.staffId;
          this.form.beginTime = this.formatDay(obj.attendanceDate);
          this.isDisable = true;
          sessionStorage.removeItem("attendanceParmas");
        }
        if (!this.userInfo.superManage) {
          this.getStaffLeaveDay();
        }
      })
    },
    getAllStaff () {
      this.$api.post(this.$url.companyStaff.listAllStaffFromWorkShop).then(res => {
        if (res) {
          this.allStaffList = res;
        }
      })
      this.$api.get(this.$url.companyLeave.listCategory).then(res => {
        if (res) {
          this.optionName = res;
        }
      })
        .catch(error => { });
    },
    onChangeStaff () {
      if (this.form.staffId && this.form.beginTime) {
        this.getStaffLeaveDay();
      }
    },
    getStaffLeaveDay () {
      this.leaveObj = {
        monthLeaveTotal: 0,
        yearPersonalLeaveTotal: 0
      }
      this.$api.get(this.$url.companyLeave.getLeaveDay, { staffId: this.form.staffId, leaveTime: this.formatDay(this.form.beginTime) }).then(res => {
        if (res) {
          this.leaveObj = res;
        }
      })
    },
    startTime (val) {
      // 开始时间
      if (val && this.form.endTime) {
        if (new Date(val).getTime() > new Date(this.form.endTime).getTime()) {
          this.form.leaveDayNum = "";
          return this.form.endTime = "";
        } else {
          let a = this.datedifference(val, this.form.endTime)
          this.$set(this.form, "leaveDayNum", a + 1)
        }

      }
      this.onChangeStaff()
    },
    endTime (val) {
      // 结束时间
      console.log(this.form.beginTime);
      if (!this.form.beginTime) {
        this.form.endTime = "";
        return this.$message.error("请先选择开始时间")
      }
      if (val && this.form.beginTime) {
        if (new Date(this.form.beginTime).getTime() > new Date(val).getTime()) {
          this.form.endTime = "";
          this.form.leaveDayNum = "";
          return this.$message.warning("开始时间不能大于结束时间");
        } else {
          let a = this.datedifference(this.form.beginTime, val)
          this.$set(this.form, "leaveDayNum", a + 1)
        }

      }
    },
    onSubmit (values) {
      if (this.userInfo.superManage) {
        this.allStaffList.map(item => {
          if (item.id == this.form.staffId) {
            this.form.staffName = item.staffName
          }
        })
      } else {
        this.form.staffName = this.userInfo.staffName
      }
      if (!this.form.staffId && this.userInfo.superManage) {
        return this.$message.error("请选择请假人")
      } else if (!this.form.leaveCateId) {
        return this.$message.error("请选择请假类型")
      } else if (!this.form.beginTime) {
        return this.$message.error("请选择请假开始时间")
      } else if (!this.form.endTime) {
        return this.$message.error("请选择请假结束时间")
      } else if (!this.form.leaveDayNum) {
        return this.$message.error("请输入请假天数")
      } else if (this.form.leaveDayNum == 0) {
        return this.$message.error("请假天数不能为零")
      } else if (isNaN(this.form.leaveDayNum)) {
        return this.$message.error("请假天数请输入数字类型")
      } else if (!this.form.leaveReason) {
        return this.$message.error("请输入备注")
      }
      this.$api.post(this.$url.companyLeave.apply, this.form).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.$emit("change", true);
          this.cancel();
        }
      }).catch(error => { });
    },
    cancel () {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  border-top: 1px solid #F5F5F5;
}

.el-form-item-update {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  margin: 0;
  background: #fff;

  &:first-child {
    margin-top: 0;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    font-weight: 500;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-radio__inner {
    width: 22px;
    height: 22px;
  }

  /deep/ .el-radio__label {
    font-size: 16px;
  }

  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-date-editor {
    width: 100%;
  }
}
</style>
